import { render, staticRenderFns } from "./DirectAppointmentPopup.vue?vue&type=template&id=56cecd6e"
import script from "./DirectAppointmentPopup.vue?vue&type=script&lang=ts"
export * from "./DirectAppointmentPopup.vue?vue&type=script&lang=ts"
import style0 from "./DirectAppointmentPopup.vue?vue&type=style&index=0&id=56cecd6e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports